import React from 'react';
import './App.css';
//import { getDefaultNormalizer } from '@testing-library/react';
import {
  BrowserRouter as Router,
  Link,
  useLocation
} from "react-router-dom";
import {ThreeDots} from './ThreeDots';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function App(props) {
  let query = useQuery();
  console.log("query:",query.get("test"));
  return (
    <div className="App">
      
      <header className="App-header">
      <img src={ require('./images/sappa_logo.png') } />
        
        <p>
          Kontaktar Dplay, vänligen vänta...
        </p>
        <ThreeDots color="#000000" height={150} width={150}/>
        <img src={ require('./images/dplay.png') } />
        <p>{query.get("code")}</p>
        <p>{query.get("scope")}</p>
      </header>

    </div>
  );
}

export default App;
